import { BasePageTrackingService } from '../BasePageTrackingService';

export class CrmTrackingService extends BasePageTrackingService {}
